import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { InvoicePayment } from '@prisma/client';
import { InvoicePaymentResourceTypeMappings } from '@aa/nest/resource';
import { invoicePaymentCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class InvoicePaymentService extends BaseResourceService<InvoicePaymentResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'invoice-payments');
  }
}
